import React from 'react';

const DamIcon = (props) => {
  return (
    <img
      alt="Zapora wodna"
      src="/static/images/icons/place_types/dam.svg"
      {...props}
    />
  );
};

export default DamIcon;
